export default {
  "title1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["What is my"])},
  "title2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["work personality?"])},
  "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["By Asiance"])},
  "start_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["START TEST"])},
  "intro_text1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["It's Monday...!"])},
  "intro_text2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rise and shine! Time for work..."])},
  "tutorial": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Swipe to see the options and tap to select"])}
}